import { Backdrop, Box, createTheme, Grid, IconButton, MuiThemeProvider, Typography } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import CheckIcon from '@material-ui/icons/Check';
import EditIcon from '@material-ui/icons/Edit';
import MUIDataTable from 'mui-datatables';
import React, { useEffect, useState } from 'react';
import Countdown from 'react-countdown';
import { useFieldArray, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import Select from '../../../components/Form/Select';
import { useAuth } from '../../../hooks/auth';
import getDefaultGridOptions from '../../../utils/componentUtils';
import { JUSTIFICATION_LIST } from '../../../utils/constants';
import utilsDate from '../../../utils/Date';
import { useStyles } from '../Style';

type props =  any;

interface IFormInput {
    exitOperator: any;
    exitConference: any;
    movement: any;
    justification: any;
}

//currentShedId = galpao em que esta fazendo a carga/descarga
const MvmShedList: React.FC<props> = ({ control, title, name, currentShedId, currentMovTypeId, showColumns, editAll=true, validatefields=true }) => {

    const classes = useStyles();
    const { t: _t } = useTranslation("General");
    const { t: tval } = useTranslation("Validation");
    const { t: ts } = useTranslation("MvmShed");
    const [circularLoading] = useState(false);
    const [meansOfMovementList, setMeansOfMovementList] = useState<any>([]);
    const [meansOfMovement01List, setMeansOfMovement01List] = useState<any>([]);
    const [justificationRequired, setJustificationRequired] = useState(false);
    const { fields: _fields, update } = useFieldArray({ control, name: name });
    const fields = _fields as Record<string, any>[];
    const { user } = useAuth();
    const [editingRow, setEditingRow] = useState<any>(null)
    const { control: formControl, setError, clearErrors, getValues, setValue } = useForm<IFormInput>({
        defaultValues: {
            exitOperator: {},
            exitConference: {},
            movement: {},
            justification: {},
        }
    });

    useEffect(() => {
        setMeansOfMovementList([{ code: 'E', label: 'Empilhadeira' }]);
        setMeansOfMovement01List([{ code: 'E', label: 'Empilhadeira' }, { code: 'P', label: 'Ponte' }]); 
     }, [])

    

    const myTheme = createTheme({
        overrides: {
            MuiTableBody: {
                root: {
                    cursor: ''
                }
            },
            MuiTableCell: {
                root: {
                    padding: 6,
                }
            },
            MuiTableHead:{
                root:{
                    height: '56px',
                    fontWeight: 'bold',
                    fontSize: 18
                }
            }
        }
    })

    const columns = [
        {
            name:'shedId',
            options: { display: false }
        },
        {
            name:'movementTypeId',
            options: { display: false }
        },
        {
            name: 'shedType',
            options: { display: false }
        },
        {
            name: 'tolerance',
            options: { display: false }
        },
        {
            name: 'shedCode',
            label: ts('shed'),
            options: {
                display: showColumns.indexOf('shedCode') >= 0,
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center",
                    width: 110,
                }),
                customBodyRender: (value: any, tableMeta: any) => {
                    return value.split(' - ')[0] + " - " + ts('type_' + tableMeta.rowData[2]); //ex: 01 - Descarga
                }
            }
        },
        {
            name: 'movementTypeDescription',
            label: ts('movementType'),
            options: {
                display: showColumns.indexOf('movementTypeDescription') >= 0,
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                })  
            }
        },
        {
            name: 'checkInDate',
            label: ts('checkInDate'),
            options: {
                display: showColumns.indexOf('checkInDate') >= 0,
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center",
                    width: 70,
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return utilsDate.DateTimeShort(value);
                }
            }
        },
        {
            name: 'entryDate',
            label: ts('entryDate'),
            options: {
                display: showColumns.indexOf('entryDate') >= 0,
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center",
                    width: 70,
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return utilsDate.DateTimeShort(value);
                }
            }
        },
        {
            name: 'entryUserName',
            label: ts('entryUserRegistration'),
            options: {
                display: showColumns.indexOf('entryUser') >= 0,
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center",
                    width: 230,
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => (
                    <>
                    <div>{value ? value : ''}</div>
                    <div>{value ? fields[tableMeta.rowIndex]['entryUserRegistration'] : ''}</div>
                    </>
                )
            }
        },
        {
            name: 'exitDate',
            label: ts('exitDate'),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center",
                    width: 70,
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return utilsDate.DateTimeShort(value);
                }
            }
        },
        {
            name: 'exitOperatorUserRegistration',
            label: ts('exitOperatorUserName'),
            options: {
                display: showColumns.indexOf('exitOperatorUser') >= 0,
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center",
                }),
                customBodyRender: (value: any, tableMeta: any) => renderExitOperatorUserRegistration(value, tableMeta)
            }
        },
        {
            name: 'exitConferenceUserRegistration',
            label: ts('exitConferenceUserName'),
            options: {
                display: showColumns.indexOf('exitConferenceUser') >= 0,
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center",
                }),
                customBodyRender: (value: any, tableMeta: any) => renderExitConferenceUserRegistration(value, tableMeta)
            }
        },
        // {
        //     name: 'exitConferenceUserName',
        //     label: ts('exitConferenceUserName'),
        //     options: {
        //         display: showColumns.indexOf('exitConferenceUser') >= 0,
        //         sort: false,
        //         setCellHeaderProps: () => ({
        //             align: "center",
        //           }),
        //         setCellProps: () => ({
        //             align: "center"
        //         })
        //     }
        // },
        {
            name: 'meansOfMovement',
            label: ts('meansOfMovement'),
            options: {
                display: showColumns.indexOf('meansOfMovement') >= 0,
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center",
                    width: 180,
                }),
                customBodyRender: (value: any, tableMeta: any ) => renderMeansOfMovementField(value, tableMeta)
            }
        },
        {
            name: 'justification',
            label: ts('justification'),
            options: {
                display: showColumns.indexOf('justification') >= 0,
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value: any, tableMeta: any ) => {                    
                    let shedId = Number(tableMeta.rowData[0]);
                    let movementTypeId = Number(tableMeta.rowData[1]);
                    let checkinDate: Date = new Date();
                    let tolerance: number = 0;

                    if (tableMeta.rowData[6])
                        checkinDate = utilsDate.ConvertYYYYMMDDToDateTime(tableMeta.rowData[6]);
                    if (tableMeta.rowData[3])
                        tolerance = utilsDate.IntervalToMilliseconds(tableMeta.rowData[3].split(':'));
                    
                    var expireDate = new Date(checkinDate.valueOf() + tolerance);

                    if (editAll || (currentShedId === shedId && currentMovTypeId === movementTypeId && Number(Date.now().valueOf()) > Number(expireDate.valueOf()) && tolerance > 0))
                        setJustificationRequired(true);

                    return (
                        <>
                            { //Se shed correto, exibir o countdown ate zerar e exigir justificativa:
                            editAll || (shedId === currentShedId && currentMovTypeId === movementTypeId) ? justificationRequired ? 
                                renderJustificationField(value, tableMeta) 
                            :
                            <Countdown
                                date={expireDate}
                                onComplete={() => { setJustificationRequired(true); }}
                                renderer={props => <></>}
                                zeroPadTime={2}
                            />
                            :
                            <>{value}</> //outro shed = exibir nada
                            }
                        </>
                    );
                }
            }
        },        
        {
            name:'order',
            label: 'order',
            options: { display: false }
        },
        {
            name: '',
            label: '',
            options: {
                display: editAll === true,
                // display: false,
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    if (editingRow !== null)
                        return (<></>)
                    else
                        return (
                            <Box display="flex">
                                <IconButton aria-label="Edit" color="primary" onClick={() => setEditingRow(tableMeta.rowIndex)}>
                                    <EditIcon fontSize='small'/>                              
                                </IconButton>
                            </Box>

                        );
                }
            }
        },
        {
            name: '',
            label: '',
            options: {      
                display: editAll === true,          
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    if (editingRow !== tableMeta.rowIndex)
                        return(<></>)
                    else
                        return (
                            <Box display="flex">
                                <IconButton aria-label="Edit" color="primary" onClick={() => setEditingRow(null)}>
                                    <CheckIcon fontSize='small'/>                              
                                </IconButton>
                            </Box>
                        )
                }
            }
        }

    ]

    const renderExitConferenceUserRegistration = (value: any, tableMeta: any) => 
    {
        //Opcoes do <Select>: registrations do array cujo shedId = ao shedId desta linha
        var shedId = Number(tableMeta.rowData[0]);
        let movementTypeId = Number(tableMeta.rowData[1]);
        var registrations = [];
        var filterRegs = fields.filter((x:any) => x.shedId === shedId && x.movementTypeId === movementTypeId).map((x:any) => x.registrations);

        if (filterRegs && filterRegs.length > 0)
            registrations = filterRegs[0];


        if (registrations && registrations.length === 1 && registrations[0].shedId === currentShedId){
            setValue('exitConference', registrations[0]);
        }

        return(
            // <span>{`${shedId} === ${currentShedId} && ${movementTypeId} === ${currentMovTypeId}`}</span>
            //Exibir o campo somente se o galpao desta linha for o mesmo selecionado pelo usuario. Senao, exibir apenas o valor
            (editAll && editingRow === tableMeta.rowIndex) || (shedId === currentShedId && movementTypeId === currentMovTypeId) ?
            <Select 
                name="exitConference"
                control={formControl} 
                onChange={(item:any) => registrationChange(tableMeta.rowIndex, item, 'exitConferenceUserRegistration', 'exitConferenceUserName') }
                options={registrations}
                fullWidth />
            : <>
                { value ? value + ' - ' + fields[tableMeta.rowIndex]['exitConferenceUserName'] : ''}
            </>
        );
    }

    const renderExitOperatorUserRegistration = (value: any, tableMeta: any) => 
    {
        // //Opcoes do <Select>: registrations do array cujo shedId = ao shedId desta linha
        var shedId = Number(tableMeta.rowData[0]);
        let movementTypeId = Number(tableMeta.rowData[1]);
        var registrations = [];
        var filterRegs = fields.filter((x:any) => x.shedId === shedId && x.movementTypeId === movementTypeId).map((x:any) => x.registrations);

        if (filterRegs && filterRegs.length > 0)
            registrations = filterRegs[0];

        if (registrations && registrations.length === 1 && registrations[0].shedId === currentShedId){
            setValue('exitOperator', registrations[0]);
            // registrationChange(tableMeta.rowIndex, value, 'exitOperatorUserRegistration', 'exitOperatorUserName');
        }

        return(
            // <span>{`${shedId} === ${currentShedId} && ${movementTypeId} === ${currentMovTypeId}`}</span>
            //Exibir o campo somente se o galpao desta linha for o mesmo selecionado pelo usuario. Senao, exibir apenas o valor
            (editAll && editingRow === tableMeta.rowIndex) || (shedId === currentShedId && movementTypeId === currentMovTypeId) ?
            <Select 
                name="exitOperator"
                control={formControl} 
                onChange={(item:any) => {
                    registrationChange(tableMeta.rowIndex, item, 'exitOperatorUserRegistration', 'exitOperatorUserName') 
                }}
                options={registrations}
                fullWidth />
            : <>
                { value ? value + ' - ' + fields[tableMeta.rowIndex]['exitOperatorUserName'] : ''}
            </>
        );
    }

    //Atualiza valor de Registration  (id = indice do array de fields, enviado para a funcao update do useFieldArray - propertyName = nome da propriedade Nome pra atualizar)
    const registrationChange = async (id: number, value: any, userProperty: string, userNameProperty: string) => {
        let item: any = fields[id];
        item[userProperty] = value?.registrationUser;
        // 'exitOperatorUserRegistration'
        item[userNameProperty] = value?.registrationUserName;
        // 'exitOperatorUserName'

        update(id, item);
        await doValidation();
    }

    const renderMeansOfMovementField = (value: any, tableMeta: any) => 
    {
        var shedId = Number(tableMeta.rowData[0]);
        let movementTypeId = Number(tableMeta.rowData[1]);
        var shedCode = tableMeta.rowData[4];
        var description = '';

        if ((shedCode !== '01' || +user.company.plantID !== 1 ) && currentShedId === shedId) {
            description = meansOfMovementList.filter((x:any) => x.code === value).map((x:any) => x.label);
            setValue('movement', meansOfMovementList[0]);
        }
        else {
            description = meansOfMovement01List.filter((x:any) => x.code === value).map((x:any) => x.label);
        }
        
        return(

            //Exibir o campo somente se o galpao desta linha for o mesmo selecionado pelo usuario. Senao, exibir apenas o valor
            (editAll && editingRow === tableMeta.rowIndex) || (shedId === currentShedId && movementTypeId === currentMovTypeId) ?
            <Select 
                name="movement"
                control={formControl} 
                onChange={(value:any) => meansOfMovementChange(tableMeta.rowIndex, value) }
                options={+user.company.plantID === 1 && shedCode === '01' ? meansOfMovement01List : meansOfMovementList}
                disabled={!(+user.company.plantID === 1 && shedCode === '01')}
                fullWidth 
                />
            : <>{description}</>
        );
    }
    
    const renderJustificationField = (value: any, tableMeta: any) => 
    {
        var shedId = Number(tableMeta.rowData[0]);
        let movementTypeId = Number(tableMeta.rowData[1]);
        // var description = JUSTIFICATION_LIST.filter((x:any) => x.code === value).map((x:any) => x.label);

        return(
            //Exibir o campo somente se o galpao desta linha for o mesmo selecionado pelo usuario. Senao, exibir apenas o valor
            (editAll && editingRow === tableMeta.rowIndex) || (shedId === currentShedId && movementTypeId === currentMovTypeId) ?
            <Select 
                name="justification"
                control={formControl} 
                onChange={(value:any) => justificationChange(tableMeta.rowIndex, value) }
                options={JUSTIFICATION_LIST}
                style={{margin: 0, paddingLeft: 6}}
                autoWidth
                fullWidth />
            : <>{value}</>
        );
    }

    const meansOfMovementChange = async (id: number, value: any) => {
        let item: any = fields[id];
        item.meansOfMovement = value ? value.code : '';
        item.movement = value ? value.code : '';
        update(id, item);

        await doValidation();
    }

    const justificationChange = async (id: number, value: any) => {

        let item: any = fields[id];
        item.justification = value.label;
        update(id, item);
        await doValidation();
    }
    
    // falta terminar o edit
    useEffect(() => {
        if (editingRow === null || !setValue)
            return

        if (fields[editingRow]["exitDate"])
        {
            let exitOperator = fields[editingRow]["registrations"]
                .filter((x: { code: any; }) => x.code === fields[editingRow]["exitOperatorUserRegistration"]);
            setValue("exitOperator", exitOperator[0]);

            let exitConference = fields[editingRow]["registrations"]
                .filter((x: { code: any; }) => x.code === fields[editingRow]["exitConferenceUserRegistration"]);
            setValue("exitConference", exitConference[0]);

            // var exitOperator = fields[editingRow].registrations
            // fields.filter((x:any) => x.shedId === fields[editingRow]["shedId"])[0].registrations
                // .filter((x: { code: any; }) => x.code === fields[editingRow]["exitOperator"])[0]

            // var exitConference = 
            // fields.filter((x:any) => x.shedId === fields[editingRow]["shedId"])[0].registrations
            //     .filter((x: { code: any; }) => x.code === fields[editingRow]["exitConference"])[0]
            // setValue("exitConference", exitConference)

            if ((fields[editingRow]["shedCode"] === '01' || +user.company.plantID === 1 ))
            {   
                let movement = meansOfMovement01List;
                setValue('movement', movement[0]);
            }else{
            
                let movement = meansOfMovementList.filter((x:any) => x.code === fields[editingRow]["meansOfMovement"]);
                setValue("movement", movement[0])
            }

            let justification = JUSTIFICATION_LIST.filter((x:any) => x.label === fields[editingRow]["justification"])[0]
            setValue("justification", justification)
        }else{
        let exitOperator = fields[editingRow]["registrations"]
        .filter((x: { code: any; }) => x.code === fields[editingRow]["exitOperatorUserRegistration"]);
        if (exitOperator.length === 1)
            setValue("exitOperator", exitOperator[0]);

        let exitConference = fields[editingRow]["registrations"]
            .filter((x: { code: any; }) => x.code === fields[editingRow]["exitConferenceUserRegistration"]);
        if (exitConference.length === 1)
            setValue("exitConference", exitConference[0]);

        let movement = meansOfMovementList.filter((x:any) => x.code === fields[editingRow]["meansOfMovement"]);
        if (movement.length === 1)
            setValue("movement", movement[0])
        

        let justification = JUSTIFICATION_LIST.filter((x:any) => x.label === fields[editingRow]["justification"])[0];
        setValue("justification", justification)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editingRow])


    //Provoca a validação assim que carregar a pagina, para impedir que o submit da pagina principal execute sem verificar os campos deste componente. Repetir a validacao quando expirar a tolerancia do checkin
    useEffect(() => {
        const validate = async ()  => {
            await doValidation();
        }

        validate();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [justificationRequired]);


    const doValidation = async() => {

        if (editAll === true)
            return

        //Validar somente o item da lista que eh do Shed escolhido:
        let index = -1;
        for(var i = 0; i < fields.length; i++)
            if (fields[i]['shedId'] === currentShedId && fields[i]['movementTypeId'] === currentMovTypeId) index = i;
            

        let item: any = fields[index]; //fields.filter((x: any) => x.shedId == currentShedId)[0];
        let hasError = false;
        if(validatefields && !await yupValidation(getValues())) hasError = true;
        
        //Sinalizar que este item do fieldArray tem erro:
        if (!!item) item.hasNoErrors = !hasError;

        update(index, item);
    }

    const yupValidation = async (data: any) => {
        clearErrors();

        try {
            const schema = Yup.object().shape({
                exitOperator: Yup.object().nullable().shape({ registrationUser: Yup.string().nullable().required(tval("requiredField")) }),
                exitConference: Yup.object().nullable().shape({ registrationUser: Yup.string().nullable().required(tval("requiredField")) }),
                movement: Yup.object().nullable().required(tval("requiredField")).shape({code: Yup.string().required(tval("requiredField"))}),
                justification: Yup.object().nullable().required(tval("requiredField")).shape({code: Yup.string().required(tval("requiredField"))})
            });
            
            await schema.validate(data, {
                 abortEarly: false
            });

            return true;
        }  catch (err) {
            var errors: any[] = []
            
            if (err instanceof Yup.ValidationError) {
                err.inner.forEach(error => {
                    if (errors.filter(element => element.error.includes(error.message)).length === 0)
                        errors.push( {prop: error.path?.split('.')[0], error: error.message})
                    

                    setError(error.path?.split('.')[0] as "exitOperator" | "exitConference" | "movement" | "justification" , { message: '' })
                })

                //Melhor nao avisar o erro via snackbar pois esta funcao eh chamada em cada onChange dos campos
                //errors.forEach(element => { 
                //    if (element.error === tval("requiredField"))
                //        enqueueSnackbar(_t("requiredFieldsValidation"), { variant: 'warning' }) 
                //    else    
                //        enqueueSnackbar(tval("theField") + ts(element.prop) + " " + element.error, { variant: 'warning' }) 
                //})
            }
 
            return false;
        }
    }


    return (
        <Grid style={{ marginTop: 20, width: "98%", marginLeft: 10, marginBottom: 10 }}>
            <Typography className={classes.root} style={{ marginLeft: 0 }} >{title}</Typography>

            <Backdrop style={{ zIndex: 9999 }} open={circularLoading}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <MuiThemeProvider theme={myTheme} >
                <MUIDataTable
                    title=""
                    data={fields}
                    columns={columns}
                    options={{
                        ...getDefaultGridOptions(_t),
                        serverSide: false,
                        pagination: false,
                        sortOrder: {
                            name: 'order',
                            direction: 'asc'
                        },
                        selectToolbarPlacement: "none",
                        filter: false,
                        search: false,
                        download: false,
                        print: false,
                        viewColumns: false,
                        selectableRows: 'none',
                    }}
                />
            </MuiThemeProvider>

        </Grid>
    )
}

export default MvmShedList